module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"googleConfiguration":"Google Configuration"},"fr":{"googleConfiguration":"Configuration Google"},"de":{"googleConfiguration":"Konfiguration Google"}}')
  delete Component.options._Ctor
}
